import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-doctor1",
  "use": "icon-doctor1-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-doctor1\"><path d=\"M7 18H18V7C18 5.89543 18.8954 5 20 5H28C29.1046 5 30 5.89543 30 7V18H41C42.1046 18 43 18.8954 43 20V28C43 29.1046 42.1046 30 41 30H30V41C30 42.1046 29.1046 43 28 43H20C18.8954 43 18 42.1046 18 41V30H7C5.89543 30 5 29.1046 5 28V20C5 18.8954 5.89543 18 7 18Z\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol